import { useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "@/config/antd";
import Avatar from "@/components/common/Avatar";
import Button from "@/components/common/Button";
import { CloseOutlined } from "@/config/antd";
import MessageDialog from "@/components/shared/dialogs/User_Dialog/Message_Dialog";
import Delete from "@/components/common/alerts/Delete";
import Success from "@/components/common/alerts/Success";
import { useLoader } from "@/hooks/LoaderProvider";

const UserDialog = ({ isVisible, onClose, user }) => {
  const [isMessageModalVisible, setIsMessageModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const { showLoader, hideLoader } = useLoader();

  const handleMessageClick = () => {
    onClose();
    setTimeout(() => {
      setIsMessageModalVisible(true);
    }, 300);
  };

  const handleBlockClick = () => {
    onClose();
    setTimeout(() => {
      setIsDeleteModalVisible(true);
    }, 300);
  };

  const handleBlockProceed = () => {
    setIsDeleteModalVisible(false);
    showLoader();

    // Simulate API call
    setTimeout(() => {
      hideLoader();
      setIsSuccessVisible(true);
    }, 2000);
  };

  const handleSuccessClose = () => {
    setIsSuccessVisible(false);
  };

  return (
    <>
      <Modal
        open={isVisible}
        onCancel={onClose}
        footer={null}
        centered
        width={350}
        closeIcon={null}
        styles={{
          body: { padding: 0 },
          content: {
            padding: 0,
            borderRadius: "16px",
            overflow: "hidden",
          },
          mask: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
        }}
        className="custom-user-dialog">
        <div className="flex flex-col bg-white">
          <div className="p-4 flex justify-end">
            <CloseOutlined
              onClick={onClose}
              className="cursor-pointer"
              style={{
                color: "var(--veegil-color-primary)",
                backgroundColor: "var(--veegil-color-secondary)",
                borderRadius: "50%",
                padding: "4px",
              }}
            />
          </div>

          <div className="flex flex-col items-center px-6 pb-6">
            <Avatar
              src={user.avatar}
              size={120}
              shape="circle"
              className="mb-4"
            />
            <h2 className="heading-regular text-primary mb-1">{user.name}</h2>
            <div className="flex items-center mb-6">
              <span className="text-darkGray mr-2">@{user.username}</span>
              <img
                src="/path/to/verification-icon.png"
                alt="Verified"
                className="w-4 h-4"
              />
            </div>
          </div>

          <div className="w-full bg-secondary p-4 flex gap-3">
            <Button
              text="Block"
              color="danger"
              className="flex-1 border border-danger text-danger"
              customBgColor="white"
              customTextColor="danger"
              onClick={handleBlockClick}
            />
            <Button
              text="Message"
              color="primary"
              className="flex-1 bg-primary text-white"
              customBgColor="primary"
              customTextColor="white"
              onClick={handleMessageClick}
            />
          </div>
        </div>
      </Modal>

      <MessageDialog
        isVisible={isMessageModalVisible}
        onClose={() => setIsMessageModalVisible(false)}
        user={user}
      />

      <Delete
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onProceed={handleBlockProceed}
        header={`Block ${user.name}?`}
        paragraph={`<span class="text-black font-bold">Are you sure you want to block ${user.name}?</span><br/><br/><span class="text-darkGray">When you block this user, they will not be able to see or participate in the event again.</span>`}
        proceedButtonText="Block"
        cancelButtonText="Cancel"
      />

      <Success
        isVisible={isSuccessVisible}
        onClose={handleSuccessClose}
        header="User Blocked"
        paragraph={`<span class="text-primary text-bold">${user.name}</span> has been blocked from attending this event.`}
        buttonText="Close"
        showCancelButton={false}
        onButtonClick={handleSuccessClose}
      />
    </>
  );
};

UserDialog.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  user: PropTypes.shape({
    avatar: PropTypes.string,
    name: PropTypes.string,
    username: PropTypes.string,
  }),
};

export default UserDialog;
